import TaxCouponEntryForm from './TaxCouponEntryForm'

export default TaxCouponEntryForm
